var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardProducts"},_vm._l((_vm.itemsPaginate),function(item,index){return _c('CardProduct',{key:index,attrs:{"item":item,"index":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }